import React, { PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { navigateExternal } from '@bettercomp/ams-spa-auth';
import { GateView } from '@bettercomp/ams-spa-auth-react';
import { getLoginUrl } from 'service/cognitoService';
import { navigateReplace } from 'components/AmsAuth/navigateReplace';

/**
 * Expired-session override for the packages' GateView: redirect through the
 * app's shared hosted-UI leg (getLoginUrl — PKCE'd, legacy-compatible) instead
 * of the package's beginLogin, because the login flow is decided per company
 * at the callback, not at redirect time. Module scope keeps the identity
 * referentially stable — the GateView contract.
 */
const redirectToSharedLogin = (path: string): void => {
  void getLoginUrl(path).then(navigateExternal);
};

/** AMS-mode auth gate: the packages' outcome decision table on next/router. */
export function AmsGate({ children }: PropsWithChildren) {
  const router = useRouter();

  return (
    <GateView currentPath={router.asPath} navigateReplace={navigateReplace} onSessionExpired={redirectToSharedLogin}>
      {children}
    </GateView>
  );
}
